import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_edit",
  "use": "icon-map_edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_edit\">\n<g id=\"icon-map_edit_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 15 7 L 13 7 C 11 18 -2 6.328125 8 3 L 8 1 C -9.597656 2.371094 14.367188 26.28125 15 7 M 12 1 C 13 2.457031 13.542969 3 15 4 C 14.519531 1.636719 14.363281 1.480469 12 1 M 5 11 C 16.34375 7.128906 8 0.09375 5 11 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_edit.svg
// module id = mGrH
// module chunks = 24